import React from 'react';

const ProjectTwrCategoriesIndex = React.lazy(() => import("./index"))
const NewProjectTwrCategories = React.lazy(() => import("./new"))
const EditProjectTwrCategories = React.lazy(() => import("./edit"))

export default[
	{path:'/project/twr/categories/:id/edit',component: EditProjectTwrCategories,name:'Edit ProjectTwrCategory'},
	{path:'/project/twr/categories/new',component: NewProjectTwrCategories,name:'New ProjectTwrCategory'},  
	{path:'/project/twr/categories',component: ProjectTwrCategoriesIndex,name:'ProjectTwrCategories'}, 
]

// import ProjectTwrCategoriesRoutes from "modules/project/twr/categories/web/routes"
// routes = _.concat(routes,ProjectTwrCategoriesRoutes)
